import React from 'react';
import { useTranslation } from 'react-i18next';
import { RecentVisitedPages } from 'shared/components/connected/recent-visited-pages';

import * as Styled from './search-results.style';

export type RecentVisitsProps = {
  onClose: () => void;
};

export const RecentVisits: React.FC<RecentVisitsProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Styled.ResultsContainer>
      <Styled.Title>{t('dialogs.search.list.title.recent')}</Styled.Title>
      <RecentVisitedPages onItem={onClose} />
    </Styled.ResultsContainer>
  );
};
